import"../../chunk-SDBWQ4EE.js";const g=(r,t,n,e,i,f=!1)=>{let s;return r&&t?s=`${r} ${t}`:r?s=r:s=t||"",[s,n,e,i].filter(Boolean).join(`, ${f?"":"<br />"}`)};export{g as addressFormatter};
